module.exports = __webpack_public_path__ + "static/media/DOEPalaceEXTA0026_design_clean_v001.361d35d6.png";